import { createMiddlewareAction } from "./createMiddlewareAction";
import { endpoints } from "../api/endpoints";
import { departamentsTypes } from "../constantes/actionTypes";

export const departamentsActions = {
  getAllDepartaments: () =>
    createMiddlewareAction({
      successType: departamentsTypes.GET_ALL_DEPARTAMENTS_SUCCESS,
      failureType: departamentsTypes.GET_ALL_DEPARTAMENTS_FAILURE,
      method: "GET",
      endpoint: endpoints.GET_ALL_DEPARTAMENTS,
    }),
  newDepartament: (departament) =>
    createMiddlewareAction({
      successType: departamentsTypes.NEW_DEPARTAMENT_SUCCESS,
      failureType: departamentsTypes.NEW_DEPARTAMENT_FAILURE,
      method: "POST",
      endpoint: endpoints.NEW_DEPARTAMENTS,
      body: departament,
    }),
  updateDepartament: (departament) =>
    createMiddlewareAction({
      successType: departamentsTypes.UPDATE_DEPARTAMENT_SUCCESS,
      failureType: departamentsTypes.UPDATE_DEPARTAMENT_SUCCESS,
      method: "PUT",
      endpoint: endpoints.UPDATE_DEPARTAMENTS,
      body: departament,
    }),
  deleteDepartament: (idDepartament) =>
    createMiddlewareAction({
      successType: departamentsTypes.DELETE_DEPARTAMENT_SUCCESS,
      failureType: departamentsTypes.DELETE_DEPARTAMENT_FAILURE,
      method: "DELETE",
      endpoint: endpoints.DELETE_DEPARTAMENTS(idDepartament),
    }),
};
